ready().then(function() {
    //Swiper arrows in title bar
    let swiperSections = $('.section-gallery, .section-quotes-list, .section-article-list, .section-authors, .section-book-list-slider');

    $.each(swiperSections, function (i, swiperSection) {
        let swiperArrows = $(swiperSection).find('.swiper-arrows');
        let swiperTitle = $(swiperSection).find('.section-title');

        swiperArrows.insertAfter(swiperTitle);
    });

    //Swiper arrows after info block
    let swipersWithInfoBlock = $('.section-book-list-tabs .swiper-arrows, .swiper-arrows');

    $.each(swipersWithInfoBlock, function (i, arrowDiv) {
        let tabInfoBlock = $(arrowDiv).closest('.book-list-container').prev();
        $(arrowDiv).appendTo(tabInfoBlock);
    });
});
